<h3 class="text-center">Cambio de Propiedad {{ tipo }}</h3>
<mat-horizontal-stepper linear #stepper>
  <mat-step [stepControl]="datosVehiculos" [editable]="isEditable">
    <ng-template matStepLabel>Vehículo</ng-template>
    <form
      [formGroup]="datosVehiculos"
      autocomplete="off"
      (ngSubmit)="siguiente()"
    >
      <h3 class="text-left" style="color: #5a1727">Datos Vehículos</h3>
      <hr />

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Matrícula(A)</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          maxlength="10"
          [class.is-invalid]="matriculaNoValido"
          formControlName="matricula"
          (input)="getVehiculo()"
        />
        <small *ngIf="matriculaNoValido">
          La matrícula es <strong>requerido</strong>
        </small>
      </mat-form-field>
      <div class="input-group">
        <mat-form-field
          appearance="outline"
          class="col-lg-3 col-md-6 col-sm-12"
        >
          <mat-label>Nº Bastidor (E)</mat-label>
          <input
            matInput
            matNativeControl
            type="text"
            maxlength="30"
            [class.is-invalid]="bastidorNoValido"
            formControlName="bastidor"
            onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)"
            maxlength="17"
          />
          <small *ngIf="bastidorNoValido">
            El numero de Bastidor es <strong>requerido</strong>
          </small>
        </mat-form-field>
        <div class="input-group-btn">
          <button
            mat-button
            class="btn btn-secondary"
            style="vertical-align: middle; margin-top: 6px"
            (click)="getDatosEITV()"
            matTooltip="Presione para recuperar los datos del vehículo desde la DGT"
          >
            Recuperar datos técnicos <mat-icon>directions_car</mat-icon>
          </button>
        </div>
      </div>

      <!--<mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Nº Bastidor(E)</mat-label>
        <input matInput matNativeControl type="text" [class.is-invalid]="bastidorNoValido"
               formControlName="bastidor" onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)" maxlength="17">
        <small *ngIf="bastidorNoValido">
          El numero de Bastidor es <strong>requerido</strong>
        </small>
      </mat-form-field>-->
      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Marca(D.1)</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          maxlength="45"
          [class.is-invalid]="marcaNoValido"
          formControlName="marca"
        />
        <small *ngIf="marcaNoValido">
          La marca es <strong>requerida</strong>
        </small>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Modelo(D.3)</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          maxlength="50"
          [class.is-invalid]="modeloNoValido"
          formControlName="modelo"
        />
        <small *ngIf="modeloNoValido">
          El modelo es <strong>requerido</strong>
        </small>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Clasificación</mat-label>
        <select matInput matNativeControl formControlName="tipoVehiculo">
          <option label="--Seleccionar--"></option>
          <option value="03">03xx – CICLOMOTOR</option>
          <option value="04">04xx – MOTOCICLETA</option>
          <option value="06">06xx – AUTOMÓVIL DE TRES RUEDAS</option>
          <option value="10">10xx – TURISMO</option>
          <option value="17">17xx – PICK UP</option>
          <option value="20">20xx – CAMIÓN MMA ≤3.500 kg</option>
          <option value="21">21xx – CAMIÓN 3.500 kg. < MMA ≤ 12.500 kg</option>
          <option value="22">22xx – CAMIÓN MMA > 12.000 kg</option>
          <option value="24">24xx – FURGÓN/FURGONETA MMA ≤ 3.500 kg</option>
          <option value="31">31xx – VEHICULO MIXTO ADAPTABLE</option>
          <option value="32">32xx – AUTO-CARAVANA MMA ≤ 3.500 kg</option>
          <option value="33">33xx – AUTO-CARAVANA MMA > 3.500 kg</option>
          <option value="66">66xx – QUAD ATV</option>
        </select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Servicio al que se destina</mat-label>
        <select matNativeControl formControlName="servicioalquesedestina">
          <option label="--Seleccionar--"></option>
          <option value="A00 - PUBL-SIN ESPECIFICAR">
            A00 - PUBL-SIN ESPECIFICAR
          </option>
          <option value="A01 - PUBL-ALQUILER SIN CONDUCTOR">
            A01 - PUBL-ALQUILER SIN CONDUCTOR
          </option>
          <option value="A04 - PUBL-TAXI">A04 - PUBL-TAXI</option>
          <option value="A07 - PUBL-AMBULANCIA">A07 - PUBL-AMBULANCIA</option>
          <option value="A13 - PUBL-POLICIA">A13 - PUBL-POLICIA</option>
          <option value="A18 - PUBL-ACTIVIDAD ECONOMICA">
            A18 - PUBL-ACTIVIDAD ECONOMICA
          </option>
          <option value="B00 - PART-SIN ESPECIFICAR">
            B00 - PART-SIN ESPECIFICAR
          </option>
          <option value="B17 - PART-VIVIENDA">B17 - PART-VIVIENDA</option>
        </select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Exencion</mat-label>
        <select matInput matNativeControl formControlName="exencion">
          <option value="0">No</option>
          <option value="1">Si</option>
        </select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Cargas</mat-label>
        <select matInput matNativeControl formControlName="cargas">
          <option label="--Seleccionar--"></option>
          <option value="NO">NO</option>
          <option value="RERSEVA DE DOMINIO">RESERVA DE DOMINIO</option>
          <option value="IVTM">IVTM</option>
          <option value="576">576</option>
        </select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Importe de CompraVenta</mat-label>
        <input
          matInput
          matNativeControl
          type="number"
          maxlength="15"
          [class.is-invalid]="baseNoValido"
          formControlName="baseImponible"
        />
        <small *ngIf="baseNoValido">
          El modelo es <strong>requerido</strong>
        </small>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>No de FRA de Venta</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          maxlength="50"
          formControlName="nroVentas"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Fecha Matriculación(I)</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          placeholder="{{ hoy.toLocaleDateString() }}"
          formControlName="fechaMatriculacion"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Cilindrada(P.1)</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          maxlength="6"
          formControlName="cilindrada"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Potencia Fiscal(P.2.1)</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          maxlength="50"
          formControlName="potenciaFiscal"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>CV(P.2)</mat-label>
        <input matInput matNativeControl type="number" formControlName="cv" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>CO2(V.7)</mat-label>
        <input
          matInput
          matNativeControl
          type="number"
          maxlength="25"
          formControlName="co2"
        />
      </mat-form-field>

      <div class="text-center mt-3" style="margin-bottom: 3rem">
        <button mat-button type="submit" class="btn-secondary" matStepperNext>
          Siguiente
        </button>
      </div>
    </form>
  </mat-step>

  <div *ngIf="ok">
    <mat-step [stepControl]="clienteVendedor | async" [editable]="isEditable1">
      <ng-template matStepLabel>Vendedor</ng-template>
      <app-cliente
        #vendedor
        [datos]="tipoVendedor"
        [isvendedor]="true"
        (datoCliente)="siguiente2($event)"
      ></app-cliente>
    </mat-step>
  </div>

  <div *ngIf="ok">
    <mat-step [stepControl]="clienteComprador | async" [editable]="isEditable2">
      <ng-template matStepLabel>Comprador</ng-template>
      <app-cliente
        #comprador
        [datos]="tipoComprador"
        (datoCliente)="siguiente3($event)"
      ></app-cliente>
    </mat-step>
  </div>

  <mat-step [stepControl]="documentos" [editable]="isEditable3">
    <ng-template matStepLabel>Documentos</ng-template>
    <app-documentos [datoTramite]="datoTramite"></app-documentos>
  </mat-step>
</mat-horizontal-stepper>
<div
  *ngIf="spinnerEITV"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png" />
  <h4 style="margin-top: 200px; color: white">Conectando con la DGT...</h4>
</div>
